<script>
  import { format } from 'svelte-i18n';
  import { Input, TabContent, TabPane, Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { Switch } from '@client/components/switch';

  import { userStore } from '@client/stores/user';

  import { USER_SETTINGS_FEATURES } from '@client/enums';

  import { merge } from '@common/utils/objects';

  export let settings = {};
  export let onUpdate = () => {};
  export let hideSalesEnabled = false;

  const onChange = (id, label, checked) => {
    if (onUpdate) {
      onUpdate('usersettings-' + id, $format(label), checked);
    }
  };

  const features = merge({}, USER_SETTINGS_FEATURES);
  const featuresKeys = [
    'enablesales',
    'autotrackemails',
    'autotracklinks',
    'autotrackdocs',
    'disablefeed',
    'trackautoforwards',
    'disablesplitsend',
    'usequickhash'
  ];

  const salesEnabled = ['autotrackemails', 'autotracklinks', 'autotrackdocs'];

  if (hideSalesEnabled) {
    featuresKeys.shift();
  }
</script>

<div class="user-features">
  <TabContent pills>
    <TabPane tabId="tracking" tab={$format('label.TRACKING')} active>
      <div class="sync-entries">
        {#each featuresKeys as item}
          {#if features[item] && (!salesEnabled.includes(item) || settings.enablesales)}
            <div class="sync-entry">
              <div class="sync-name">
                <div>
                  {@html $format(features[item].label) || item}
                  <Icon name="help-circle" id="{item}-tooltip" />
                </div>
                <Tooltip target="{item}-tooltip" placement="top">
                  {@html $format(features[item].description)}
                </Tooltip>
              </div>
              <div class="sync-actions">
                <Switch
                  bind:checked={settings[item]}
                  on:change={() => onChange(item, features[item].label, settings[item])}
                />
              </div>
            </div>
          {/if}
        {/each}
      </div>
    </TabPane>
    <TabPane tabId="attachments" tab={$format('label.ATTACHMENTS')}>
      <div class="sync-entries">
        {#each ['attsattop', 'keepattachments', 'enableatticon'] as item}
          {#if features[item]}
            <div class="sync-entry">
              <div class="sync-name">
                <div>
                  {@html $format(features[item].label) || item}
                  <Icon name="help-circle" id="{item}-tooltip" />
                </div>
                <Tooltip target="{item}-tooltip" placement="top">
                  {@html $format(features[item].description)}
                </Tooltip>
              </div>
              <div class="sync-actions">
                <Switch
                  bind:checked={settings[item]}
                  on:change={() => onChange(item, features[item].label, settings[item])}
                />
              </div>
            </div>
          {/if}
        {/each}
      </div>
    </TabPane>
    <TabPane tabId="email" tab={$format('label.EMAIL')}>
      <div class="sync-entries">
        {#each ['enabletiming', 'trackautobcc'] as item}
          {#if features[item]}
            <div class="sync-entry">
              <div class="sync-name">
                <span>{@html $format(features[item].label) || item}</span>
                <Icon name="help-circle" id="{item}-tooltip" />
                <Tooltip target="{item}-tooltip" placement="top">
                  {@html $format(features[item].description)}
                </Tooltip>
              </div>
              <div class="sync-actions">
                <Switch
                  bind:checked={settings[item]}
                  on:change={() => onChange(item, features[item].label, settings[item])}
                />
              </div>
            </div>
          {/if}
        {/each}
        {#each ['autobcc', 'donottrack'] as item}
          {#if features[item]}
            <div class="sync-entry">
              <div class="sync-name">
                <span>{@html $format(features[item].label) || item}</span>
                <Icon name="help-circle" id="{item}-tooltip" />
                <Tooltip target="{item}-tooltip" placement="top">
                  {@html $format(features[item].description)}
                </Tooltip>
              </div>
              <div class="sync-actions">
                <Input
                  type="text"
                  class="w-200"
                  placeholder={$format(features[item].placeholder) || ''}
                  bind:value={settings[item]}
                  on:change={() => onChange(item, features[item].label, settings[item])}
                />
              </div>
            </div>
          {/if}
        {/each}
      </div>
    </TabPane>
  </TabContent>
</div>

<style lang="scss" src="./user-features.scss"></style>
